// GENERAL
import React from "react";

// COMPONENTS
import { BaseContainer, BaseText } from "../../../../../../components";

import { getFontAwesomeIcon } from "../../../../../../utils";

// TYPES
import { OrderShipmentMethodDetailsProps } from "../../types";

const OrderShipmentMethodDetails: React.FC<OrderShipmentMethodDetailsProps> = ({
	fields,
	notifications,
	submittedBy,
	priority,
}) => {
	// CLASSES:

	//// SETTINGS FROM FIELDS ////
	const isShippingUrgencyVisible =
		fields?.DUMMYORDERDETAILSFIELDS[5]?.ADDITIONALORDERDETAILS?.urgency
			?.isVisible;
	const isSubmittedByVisible =
		fields?.DUMMYORDERDETAILSFIELDS[5]?.ADDITIONALORDERDETAILS?.submittedBy
			?.isVisible;
	const isNotificationsVisible =
		fields?.DUMMYORDERDETAILSFIELDS[5]?.ADDITIONALORDERDETAILS
			?.notifications?.isVisible;

	//// TEXT FROM FIELDS ////
	const shippingUrgencyLabel =
		fields?.DUMMYORDERDETAILSFIELDS[5]?.ADDITIONALORDERDETAILS?.urgency
			?.label;
	const submittedByLabel =
		fields?.DUMMYORDERDETAILSFIELDS[5]?.ADDITIONALORDERDETAILS?.submittedBy
			?.label;
	const notificationsLabel =
		fields?.DUMMYORDERDETAILSFIELDS[5]?.ADDITIONALORDERDETAILS
			?.notifications?.label;

	const priorityFlagColor =
		priority === "High" ? "text-crimson-700" : "text-flagIndigo";

	return (
		<>
			<BaseContainer
				columnShape="semi-rounded"
				borderColor="navy-200"
				backgroundColor="bg-navy-100"
				isDisabled={false}
				columnContainerClasses="text-sm flex flex-col py-3 px-4 text-left border-transparent h-full"
			>
				<>
					<div className="font-omnes-medium mb-3">
						{fields?.labels?.additionalOrderDetailsTitle}
					</div>
					<div
						className={`grid ${
							isShippingUrgencyVisible
								? "grid-cols-1 md:grid-cols-4 gap-1"
								: "grid-cols-1 md:grid-cols-2 gap-4 "
						}`}
					>
						{isShippingUrgencyVisible && (
							<div
								className={` ${
									isShippingUrgencyVisible
										? "col-span-1"
										: "col-span-2"
								}`}
							>
								<BaseText
									text={
										<span className="flex flex-col">
											<span className="font-omnes-medium">
												{shippingUrgencyLabel}
											</span>
											<div>
												<span
													className={`${priorityFlagColor} pr-2 font-omnes-regular`}
												>
													{getFontAwesomeIcon(
														"flag",
														"solid",
													)}
												</span>
												{priority}
											</div>
										</span>
									}
									tag="p"
									color="text-navy-500"
									size="text-sm"
								/>
							</div>
						)}
						{isSubmittedByVisible && (
							<div className={`col-span-1`}>
								<BaseText
									text={
										<>
											<span className="font-omnes-medium">
												{submittedByLabel}
											</span>
											<span className="font-omnes-regular">
												{submittedBy}
											</span>
										</>
									}
									tag="p"
									color="text-navy-500"
									size="text-sm"
									additionalClasses="flex flex-col"
								/>
							</div>
						)}
						{isNotificationsVisible && (
							<div
								className={` ${
									isShippingUrgencyVisible
										? "col-span-1 md:col-span-2"
										: "col-span-1"
								}`}
							>
								{/* hiding p tag from screen readers, and using aria-label on ul in order to group list title programmatically for screen readers */}
								<BaseText
									text={notificationsLabel}
									tag="p"
									color="text-navy-500"
									size="text-sm"
									fontFamily="font-omnes-medium"
									ariaHidden={true}
								/>
								<ul
									aria-label={
										fields?.labels?.notificationsAriaLabel
									}
								>
									{notifications &&
										notifications?.map(
											(
												notification: Record<
													string,
													any
												>,
												index: number,
											) => (
												<li key={index}>
													{notification?.emailAddress ||
														"—"}
												</li>
											),
										)}
								</ul>
							</div>
						)}
					</div>
				</>
			</BaseContainer>
		</>
	);
};

export default OrderShipmentMethodDetails;
